import { makeStyles } from "tss-react/mui"
import { Grid, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"

const useStyles = makeStyles()(() => ({
    text: {
        color: "#64748B",
        paddingBottom: ".5rem",
    },
}))

type StandardNoResultTextProps = Readonly<{
    noResultText?: string
}>

export function StandardNoResultText({ noResultText }: StandardNoResultTextProps) {
    const { classes } = useStyles()
    return (
        <Grid container justifyContent="center" marginTop="10rem">
            <Typography variant="h6" className={classes.text}>
                {noResultText ?? (
                    <LocalizedStrict id="production-list-no-result">
                        <>No result</>
                    </LocalizedStrict>
                )}
            </Typography>
        </Grid>
    )
}
